<template>
    <FormSection
        title="Additional Emergency Contact"
        type="his-section"
        :full-height="false"
        :application-id="Number(application)"
    >
        <template #content>
            <div class="col col-12">
                <section class="row py-3 g-0">
                    <div class="col-12 px-4 col-md-12 g-0">
                        <div class="col-12">
                            <div class="form-group col-12 ps-0">
                                <div
                                    v-for="(contact, index) in referral.Contacts.AdditionalEmergencyContacts"
                                    :key="`${index}`"
                                >
                                    <FormSection :application-id="application" :showBackground="false" class="mt-1">
                                        <template #content>
                                            <div class="d-flex flex-column px-4 py-2" slot="content">
                                                <div class="col-12">
                                                    <h6 class="mb-2 d-flex align-items-center">
                                                        <b class="me-2">Additional Emergency Contact {{ index + 1 }}</b>
                                                        <button
                                                            class="btn table-btn btn-outline-danger me-1 ms-auto"
                                                            @click="removeEmergencyContact(index)"
                                                        >
                                                            <i class="fas fa-trash-alt"></i>
                                                        </button>
                                                    </h6>
                                                </div>
                                                <div class="row col-12">
                                                    <div class="col-6">
                                                        <div class="form-group">
                                                            <label for="auth-contact-first-name-add">
                                                                First Name
                                                            </label>
                                                            <input
                                                                name="auth-contact-first-name-add"
                                                                class="form-control"
                                                                maxlength="50"
                                                                type="text"
                                                                placeholder="Enter First Name"
                                                                v-model="contact.FirstName"
                                                            />
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="auth-contact-last-name-add"> Last Name </label>
                                                            <input
                                                                name="auth-contact-last-name-add"
                                                                class="form-control"
                                                                maxlength="50"
                                                                type="text"
                                                                placeholder="Enter Last Name"
                                                                v-model="contact.LastName"
                                                            />
                                                        </div>

                                                        <div class="form-group">
                                                            <label for="auth-contact-relationship-add">
                                                                Relationship
                                                            </label>
                                                            <select
                                                                class="form-select"
                                                                name="auth-contact-relationship-add"
                                                                v-model="contact.RelationOption"
                                                            >
                                                                <option
                                                                    v-for="(
                                                                        relation, index
                                                                    ) of referralOptions.relation"
                                                                    :key="index"
                                                                    :value="relation.value"
                                                                >
                                                                    {{ relation.text }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="auth-contact-rel-desc"> Other </label>
                                                            <input
                                                                name="auth-contact-rel-desc"
                                                                class="form-control"
                                                                type="text"
                                                                placeholder="Enter Relationship"
                                                                v-model="contact.Relationship"
                                                            />
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="auth-contact-email-add"> Email </label>
                                                            <input
                                                                name="auth-contact-email-add"
                                                                class="form-control"
                                                                maxlength="50"
                                                                type="text"
                                                                placeholder="Enter Email"
                                                                v-model="contact.EmailAddress"
                                                            />
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="referral-mobile-number-add">
                                                                Mobile Phone
                                                                <i
                                                                    class="fas fa-question-circle"
                                                                    v-tooltip="{
                                                                        title: 'For emergency preparedness, patient will be contacted at this number. This will also populate to the emergency preparedness report.'
                                                                    }"
                                                                ></i>
                                                            </label>
                                                            <input
                                                                name="referral-mobile-number-add"
                                                                type="text"
                                                                class="form-control phone-number-input"
                                                                maxlength="10"
                                                                placeholder="Enter Number"
                                                                v-number-only
                                                                v-model="contact.PrimaryPhone"
                                                            />
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="referral-alternate-phone-add">
                                                                Alternate Phone
                                                            </label>
                                                            <input
                                                                name="referral-alternate-phone-add"
                                                                type="text"
                                                                class="form-control phone-number-input"
                                                                maxlength="10"
                                                                placeholder="Enter Number"
                                                                v-number-only
                                                                v-model="contact.AlternatePhone"
                                                            />
                                                        </div>
                                                        <div class="w-100"></div>
                                                        <div>
                                                            <p>Representative</p>
                                                            <div class="form-check custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    class="form-check-input"
                                                                    :id="`Additional-Legal-Representative-${index}`"
                                                                    :value="1"
                                                                    :checked="contact.Representative === 1"
                                                                    v-model="contact.Representative"
                                                                />
                                                                <label
                                                                    class="form-check-label"
                                                                    :for="`Additional-Legal-Representative-${index}`"
                                                                >
                                                                    Legal Representative
                                                                </label>
                                                            </div>
                                                            <div class="form-check custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    class="form-check-input"
                                                                    :id="`Additional-Patient-Selected-Representative-${index}`"
                                                                    :value="2"
                                                                    :checked="contact.Representative === 2"
                                                                    v-model="contact.Representative"
                                                                />
                                                                <label
                                                                    class="form-check-label"
                                                                    :for="`Additional-Patient-Selected-Representative-${index}`"
                                                                >
                                                                    Patient Selected Representative
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="col-12 form-group d-flex">
                                                            <div
                                                                class="form-check custom-checkbox form-check-inline mt-2"
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    :id="`same-patient-addr-add-${index}`"
                                                                    class="form-check-input au-target"
                                                                    v-model="contact.SameAsPatientAddress"
                                                                    @change="makeEmergencyAsPrimary(contact, index)"
                                                                />
                                                                <label
                                                                    class="form-check-label"
                                                                    :for="`same-patient-addr-add-${index}`"
                                                                >
                                                                    <span class="me-1">Same as Patient Address</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <ReferralAddressForm
                                                            :index="index"
                                                            :address="contact.Address"
                                                            :showZipFourCode="false"
                                                            :addressType="`AdditionalEmergencyContacts${index}`"
                                                            :zipChanged="handleZipChange"
                                                            :county-data="
                                                                index === 0
                                                                    ? additional1
                                                                    : index === 1
                                                                    ? additional2
                                                                    : additional3
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </FormSection>
                                </div>
                            </div>
                            <button class="btn btn-xs btn-primary mb-2" @click="addEmergencyContact()">
                                + Add Emergency Contact
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./EmergencyContactAdditional.ts"></script>
